// 民泊詳細 src\pages\MinpakuDetail.jsx

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Breadcrumb from "../components/Breadcrumb";
import { extractMapSrc } from "../utils/format";

const MinpakuDetail = () => {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setNotFound(false);
    fetch(`/api/public/minpaku/${id}`)
      .then(res => {
        if (!res.ok) {
          setNotFound(true);
          return null;
        }
        return res.json();
      })
      .then((data) => {
        if (data) {
          setItem(data);
          setActiveIdx(0);
        }
      })
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound)
    return (
      <p className="text-center py-8">この施設は現在公開されていません。</p>
    );
  if (!item) return <p className="text-center py-8">読み込み中...</p>;

  return (
    <>  
        {/* パンくずリスト */}
        <Breadcrumb extra={item.name} />

        <div className="max-w-3xl mx-auto py-8 px-4">
        <h1 className="text-2xl font-bold mb-4">{item.name}</h1>
        <p className="text-sm text-gray-600 mb-6">
            {new Date(item.createdAt).toLocaleDateString("ja-JP", {
            year: "numeric", month: "long", day: "numeric"
            })}
        </p>

        {/* 写真ギャラリー（メイン＋サムネイル） */}
        {Array.isArray(item.photos) && item.photos.length > 0 && (
          <div className="mb-6">
            <img
              src={item.photos[activeIdx] || item.photos[0]}
              alt={`${item.name}のメイン写真`}
              className="w-full h-72 md:h-96 object-contain bg-gray-100 rounded"
            />
            {item.photos.length > 1 && (
              <div className="mt-2 flex gap-2 overflow-x-auto pb-1">
                {item.photos.map((url, i) => (
                  <button
                    type="button"
                    key={i}
                    onClick={() => setActiveIdx(i)}
                    className={`shrink-0 rounded border-2 ${
                      i === activeIdx ? "border-primary" : "border-transparent"
                    }`}
                  >
                    <img
                      src={url}
                      alt={`${item.name}-${i + 1}`}
                      className="h-16 w-24 object-cover rounded"
                    />
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {/* 紹介文 */}
        <div className="mb-6 whitespace-pre-wrap">{item.body}</div>

        {/* 予約リンク */}
        <div className="mb-6">
            <h2 className="font-semibold mb-2">予約サイト</h2>
            <ul className="list-disc pl-5">
            {item.reservationUrls.map((r, i) => (
                <li key={i}>
                <a
                    href={r.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                >
                    {r.label}
                </a>
                </li>
            ))}
            </ul>
        </div>

        {/* Google Map 埋め込み */}
        {item.mapUrl && (
            <div className="mb-4">
            <h2 className="font-semibold mb-2">地図</h2>
            <iframe
                src={extractMapSrc(item.mapUrl)}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
            />
            </div>
        )}

        <Link to="/businessContent/minpaku" className="text-blue-600 hover:underline">
            ← 一覧に戻る
        </Link>
        </div>
    </>
  );
};

export default MinpakuDetail;
